import _objectSpread from "@babel/runtime/helpers/objectSpread";
import makePlainReducer from '../../../../creators/reducers/makePlainReducer';

var singleChange = function singleChange(state, action) {
  var _objectSpread2;

  return _objectSpread({}, state, (_objectSpread2 = {}, _objectSpread2[action.id] = _objectSpread({}, state[action.id], action.changes), _objectSpread2));
};
/**
 * Creator function for the data reducer in the pending model. Supports the
 * `CREATE_PENDING_DATA`, `UPDATE_PENDING_DATA`, `DESTROY_PENDING_DATA`, and
 * `REMOVE_TOKEN` action.
 *
 * @param {Object} options The options for the creator
 * @param {Object} options.customConfig Any custom handlers for the reducer
 * @return {Function) The newly created reducer
 *
 * @public
 * @author Connor Taylor
 */


var data = function data(_ref) {
  var _ref$customConfig = _ref.customConfig,
      customConfig = _ref$customConfig === void 0 ? {} : _ref$customConfig;
  return makePlainReducer({
    config: _objectSpread({
      CREATE_PENDING_DATA: singleChange,
      UPDATE_PENDING_DATA: singleChange,
      DESTROY_PENDING_DATA: function DESTROY_PENDING_DATA(state, action) {
        var newState = _objectSpread({}, state);

        delete newState[action.id];
        return newState;
      },
      REMOVE_TOKEN: function REMOVE_TOKEN() {
        return {};
      }
    }, customConfig),
    initialState: {}
  });
};
/** @component */


export default data;